import CsatSetting from "./KrCsatSetting.vue";
import { install } from "@kurundata-ui-questionnaire/utils/install";

const KrCsatSetting = install(CsatSetting); // 生成带有 install 方法的组件

export default KrCsatSetting;
